import styled from "styled-components";
import { mobileChangeWidth } from "../../../styles/theme";


const StepImg = styled.img`
  width: 22px;
  height: 22px;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    width: 16px;
    height: 16px;
  }
`;

interface StepLabelProps {
    fontWeight?: string;
    fontSize?: string;
    color?: string;
}

const StepLabel = styled.div<StepLabelProps>`
  font-weight: ${(props) => props.fontWeight};
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  text-align: center;
  @media only screen and (max-width: ${mobileChangeWidth}) {
    font-size: 14px;
  }
`;

export { StepImg, StepLabel }; 